'use client'

import styles from './styles.module.scss'
import { useTranslations } from 'next-intl'
import Merchant from '@/src/interfaces/merchant/merchant'
import { useMerchant } from '@/src/context/merchant/merchant-context'
import MerchantLogo from '../logo/merchant-logo'
import MerchantCover from '../cover/merchant-cover'
import { useEffect, useState } from 'react'
import Modal from '../../helpers/overlays/modal/modal'
import MerchantProfile from '../profile/merchant-profile'
import SvgWhatsapp from '@/src/assets/svgs/social/whatsapp-monocolor.svg'
import SvgPhone from '@/src/assets/svgs/collection/phone-call.svg'
import BaseLoading from '../../helpers/base-loading/base-loading'
import { Overlay } from '../../helpers/overlays/overlay'
import BasicInfos from '../basic-infos/basic-infos'
import { isMerchantInHourRange } from '../../misc/next-opening-hour/next-opening-hour'

interface Props {
    merchantSummary?: Merchant.ResponseSummary
}

export default function MerchantCard(props: Props) {
    const t = useTranslations('merchant')
    const { polling, localMode, merchantDetailed } = useMerchant()
    const [modal, setModal] = useState(false)

    const isInHourRange = isMerchantInHourRange(merchantDetailed?.model?.openingHours ?? [])
    const canSchedule = merchantDetailed?.model?.scheduleConfiguration.schedulingOrdersAllowed
    const isUnavailableToOrder = isInHourRange && polling?.model?.status === 'Closed' && !canSchedule

    const renderStatus = () => {
        const isOrderingWhatsApp = merchantDetailed?.model?.orderingMethod === 'WhatsApp';
        const whatsApp = isOrderingWhatsApp ? <div className={styles.whatsAppLogo}><SvgWhatsapp className={styles.svgWhatsApp} /></div> : <></>

        if (polling?.isLoading || merchantDetailed?.isLoading) {
            return (
                <div>
                    <BaseLoading><aside className={styles.loading} /></BaseLoading>
                </div>
            )
        }

        if (isUnavailableToOrder) {
            return (
                <div className={`${styles.statusUnavailable} font-sm`}>
                    <div className={styles.phoneArea}>
                        <SvgPhone />
                    </div>
                    Ligue para pedir
                </div>
            )
        }

        if (polling?.model?.isOpened)
            return <span className={`${styles.statusOpened} font-sm`}>{whatsApp}{t('statusOpened')}</span>

        if (!polling?.model?.isOpened && canSchedule)
            return <span className={`${styles.statusClosed} font-sm`}>{whatsApp}{t('statusClosed')} - Agendar pedido</span>

        return <span className={`${styles.statusClosed} font-sm`}>{whatsApp}{t('statusClosed')}</span>
    }

    const openProfile = () => {
        Overlay.openWithQs('q', 'perfil', () => setModal(true))
    }

    useEffect(() => {
        Overlay.startPopstateListener(() => setModal(false))
    }, [])

    return (
        <>
            {
                modal &&
                <Modal
                    isInterceptRouting={false}
                    options={{
                        headProps: {
                            elToObserveId: "merchant-title", headTitle: merchantDetailed?.model?.name,
                            backgroundHeadTheme: "primary"
                        },
                        animation: window.innerWidth > window.innerHeight ? 'pop' : 'fade'
                    }}
                    onClose={() => setModal(false)}
                    isOpen={modal}
                >
                    <MerchantProfile />
                </Modal>
            }
            <section className={styles.container} id='page-header'>
                <div className={styles.coverArea}>
                    <MerchantCover className={styles.coverImage} />
                    <div onClick={openProfile}>
                        <MerchantLogo className={styles.merchantLogoArea} />
                    </div>
                </div>
                <a
                    href={isUnavailableToOrder ? `tel:${merchantDetailed?.model?.phone}` : undefined}
                    onClick={() => isUnavailableToOrder ? null : openProfile()}
                    className={styles.infoMerchant}
                >
                    <h1 className={`${styles.name} font-lg`}>{props.merchantSummary!.name}</h1>
                    {(!localMode && merchantDetailed?.model?.orderingMethod !== 'Disabled') && renderStatus()}
                </a>
            </section>
            <BasicInfos openProfile={openProfile} />
        </>
    )
}